<div id="main-container">
    <router-outlet></router-outlet>
</div>
